export default __webpack_public_path__ + "static/card-3-486944193dd362c9b569e3d4d9b0b054.svg";